import React, { useEffect } from 'react'
import { PROJECT_MANAGEMENT } from '../../../constants/route-paths'
import idx from 'idx'
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { resolveProjectType } from "../utils/resolve-project-type";
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import ViewPurchaseOrderComponent from '../../../components/po/view';
import { isEmpty } from 'lodash';
import { updateProjectSummaryData } from '../utils/get-project-summary';

function ViewPurchaseOrder(props) {

  const { projectId, poId } = useParams();
  let [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { projectDetail = {}, projectSummary, project: projectState } = useSelector(state => state)
  let projectType = searchParams.get("project-type")
    || idx(projectDetail, _ => _.project.projectDataType)
    || idx(projectDetail, _ => _.project.res.projectType)
    || idx(projectSummary, _ => _.project.projectDataType)
    || idx(projectSummary, _ => _.project.res.projectType);

  projectType = resolveProjectType(projectType, projectState);

  useEffect(() => {
    if (projectSummary && isEmpty(projectSummary.project)) updateProjectSummaryData({ projectId, dispatch });
  }, []);
  const viewProjectList = () => navigate(`/projects?project-type=${projectType}`);
  const viewProject = () => navigate(`/${PROJECT_MANAGEMENT}/view/${projectId}`);
  const subTab = searchParams.get("subTab") || searchParams.get("returnSubTab") || "active";
  const viewPoList = () => navigate(`/${PROJECT_MANAGEMENT}/purchase-order/${projectId}?subTab=${subTab}`);
  const editHandler = () => navigate(`/${PROJECT_MANAGEMENT}/purchase-order/${projectId}/edit/${poId}`);
  return (
    <div className="purchase-order-block" data-cy="view-purchase-order">
      <div className="purchase-order-block">
        <ViewPurchaseOrderComponent
          poId={poId}
          cancelHandler={viewPoList}
          editHandler={editHandler}
          sourcePage="project-po-list"
          breadcrumb={
            <div className="col-12 breadcrumb-block p-0" data-cy="breadcrumb">
              <Breadcrumb>
                <Breadcrumb.Item onClick={viewProjectList} data-cy="projects">PROJECTS</Breadcrumb.Item>
                <Breadcrumb.Item onClick={viewProject} data-cy="project-name">{idx(projectDetail, _ => _.project.projectName) || idx(projectSummary, _ => _.project.projectName)}</Breadcrumb.Item>
                <Breadcrumb.Item onClick={viewPoList} data-cy="purchase-order-list">Purchase Order LIST</Breadcrumb.Item>
                <Breadcrumb.Item active data-cy="purchase-order">Purchase Order</Breadcrumb.Item>
              </Breadcrumb>
            </div>
          }
        />
      </div>
    </div>
  )
}

export default ViewPurchaseOrder
